// src/services/conflictResolution.service.js
import { api } from './api';

class ConflictResolutionService {
    /**
     * Request conflict resolution
     * @param {Object} data - Resolution request data
     * @param {string} data.conflictDate - Date of conflict (YYYY-MM-DD)
     * @param {string} data.resolutionType - 'cancel_leave' or 'cancel_attendance'
     * @param {string} data.reason - Reason for the request
     * @param {number} data.attendanceId - ID of the attendance record
     * @param {number} data.leaveRequestId - ID of the leave request
     */
    async requestResolution(data) {
        try {
            const response = await api.post('/api/conflict-resolution/request', data);
            return response.data;
        } catch (error) {
            console.error('Error requesting conflict resolution:', error);
            throw error;
        }
    }

    /**
     * Get my conflict resolution requests
     * @param {string} status - Optional status filter ('pending', 'approved', 'rejected')
     */
    async getMyRequests(status = null) {
        try {
            const params = status ? { status } : {};
            const response = await api.get('/api/conflict-resolution/my-requests', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching my conflict resolution requests:', error);
            throw error;
        }
    }

    /**
     * Get pending requests for manager/admin approval
     */
    async getPendingRequests() {
        try {
            const response = await api.get('/api/conflict-resolution/pending');
            return response.data;
        } catch (error) {
            console.error('Error fetching pending conflict resolution requests:', error);
            throw error;
        }
    }

    /**
     * Review a conflict resolution request (manager/admin)
     * @param {number} requestId - ID of the request
     * @param {string} action - 'approve' or 'reject'
     * @param {string} comments - Optional reviewer comments
     */
    async reviewRequest(requestId, action, comments = '') {
        try {
            const response = await api.put(`/api/conflict-resolution/review/${requestId}`, {
                action,
                comments
            });
            return response.data;
        } catch (error) {
            console.error('Error reviewing conflict resolution request:', error);
            throw error;
        }
    }

    /**
     * Get all conflict resolution requests (admin only)
     * @param {Object} filters - Optional filters
     * @param {string} filters.status - Status filter
     * @param {string} filters.startDate - Start date filter
     * @param {string} filters.endDate - End date filter
     */
    async getAllRequests(filters = {}) {
        try {
            const response = await api.get('/api/conflict-resolution/all', { params: filters });
            return response.data;
        } catch (error) {
            console.error('Error fetching all conflict resolution requests:', error);
            throw error;
        }
    }
}

export default new ConflictResolutionService();
